import axios, { AxiosError, AxiosResponse } from 'axios';
import AppConsts from '../lib/appconst';
import { message } from 'antd';

const http = axios.create({
  baseURL: AppConsts.remoteInfrastructureServiceBaseUrl,
  timeout: 30000,
  headers: {
    'x-api-key': AppConsts.vehicleApiKey,
  },
});

http.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error: AxiosError) => {
    const { data, status } = error?.response as AxiosResponse;
    switch (status) {
      case 403:
        message.error({ content: data.error.message });
        break;
      case 404:
        window.location.href = '/not-found';
        break;
      case 500:
        message.error({ content: data.error.message });
        break;
    }
    return Promise.reject(error);
  }
);

export default http;
